import React, {useState, ReactNode} from 'react';
import Popper from '@material-ui/core/Popper';
import {makeStyles} from '@material-ui/core/styles';
import {lightTheme} from '@components/@theme/lightTheme';

interface UnwrappedTooltipProps {
  children: JSX.Element;
  content: ReactNode;
}

export const UnwrappedTooltip: React.FC<UnwrappedTooltipProps> = ({children, content}) => {
  const [anchorEl, setAnchorEl] = useState();
  const {popover} = useStyles(lightTheme);

  if (!children) return null;

  return (
    <>
      {React.cloneElement(children, {
        onMouseEnter: e => setAnchorEl(e.currentTarget),
        onMouseLeave: () => setAnchorEl(undefined),
      })}
      <Popper style={{pointerEvents: 'none'}} open={!!anchorEl} anchorEl={anchorEl}>
        <div className={popover}>{content}</div>
      </Popper>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  popover: {
    backgroundColor: '#FFFFFF',
    padding: 10,
    boxShadow: theme.shadows[5],
  },
}));
